/** The company whose preferences a form renders and submits. */
export type PreferenceCompanyScope = {
  code: string | null;
  internal: boolean;
};

export type PreferenceFormContext = {
  companyScope: PreferenceCompanyScope;
  isMultiFloor?: boolean;
};

export type Preference = {
  id: string;
  name: string;
  description?: string | null;
  partnerId?: string;
  layerNumber?: number;
  isSetting: boolean;
  isLeaf: boolean;
  children: Preference[];
  label?: string | null;
  value?: string;
  updatedAt?: string;
  totalUnits?: number;
  remarks?: string;
  optimizedValue?: boolean;
  nsw?: boolean;
  qld?: boolean;
  sa?: boolean;
  vic?: boolean;
  wa?: boolean;
};
export type UserPreference = {
  id: string;
  title: string;
  description: string;
  preferenceType: UserPreferenceType;
  createdAt: string;
  updatedAt: string;
  createdByName?: string;
  createdByEmail?: string;
  data?: Preference[];
  userId: string | null;
};

export interface PreferenceLeaf {
  preferenceId?: string;
  lookupTableId?: string;
  totalUnits?: number;
  remarks?: string;
}

export type PreferencesRaw = {
  raw: Record<string, string[]>;
};
export interface SelectedPathItem {
  id: string;
  name: string;
  layerNumber?: number;
  isLeaf: boolean;
}

export interface PreferenceWithPath {
  category: Preference;
  selectedPath: SelectedPathItem[];
  leafNode: Preference | null;
  totalUnits?: number;
  remarks?: string;
}
export type AddEditUserPreferencePayload = {
  preferenceType: UserPreferenceType;
  title: string;
  description?: string;
  preferences: PreferenceLeaf[];
  /** Template these selections were picked from; absent when built by hand. */
  templatePreferenceId?: string;
};
export enum UserPreferenceType {
  GLOBAL = 'GLOBAL',
  JOB = 'JOB',
  SYSTEM = 'SYSTEM',
}
// Admin UI
export type PreferenceEntity = {
  id: string;
  name: string;
  label?: string | null;
  description?: string | null;
  parentId: string | null;
  layerNum: number;
  isSetting: boolean;
  isLeaf: boolean;
  nsw: boolean;
  qld: boolean;
  sa: boolean;
  vic: boolean;
  wa: boolean;
  children?: PreferenceEntity[];
};

export type AddEditPreferencePayload = {
  id?: string;
  name: string;
  label?: string | null;
  description?: string | null;
  parentId: string | null;
  layerNum: number;
  isSetting: boolean;
  isLeaf: boolean;
  nsw: boolean;
  qld: boolean;
  sa: boolean;
  vic: boolean;
  wa: boolean;
  stateApplyToChildren?: boolean;
};

export enum LookupTableType {
  RETURN_AIR_ALUMINIUM = 'RETURN_AIR_ALUMINIUM',
  RETURN_AIR_PURTECH = 'RETURN_AIR_PURTECH',
  SUPPLY_AIR = 'SUPPLY_AIR',
}

export type LookupTable = {
  id: string;
  userId: string | null;
  preferenceType: UserPreferenceType;
  tableType: LookupTableType;
  nsw: boolean;
  qld: boolean;
  sa: boolean;
  vic: boolean;
  wa: boolean;
  title: string;
  description: string | null;
  data: Record<string, number | string | null>[];
  createdAt: string;
  updatedAt: string;
};

export type LookupTablePayload = {
  preferenceType: UserPreferenceType;
  tableType: LookupTableType;
  title: string;
  description?: string;
  nsw?: boolean;
  qld?: boolean;
  sa?: boolean;
  vic?: boolean;
  wa?: boolean;
  data: Record<string, number | string | null>[];
};
